import { render, staticRenderFns } from "./BaseContentLoader.vue?vue&type=template&id=1da044ba&"
import script from "./BaseContentLoader.vue?vue&type=script&lang=js&"
export * from "./BaseContentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports